import { useState, useRef, useEffect } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import NotificationPanel from './NotificationPanel';
import styles from './NotificationBell.module.css';

const NotificationBell = ({ pendingCount, notifications, onReload }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.bellContainer} ref={containerRef}>
      <button className={styles.bellButton} onClick={() => setIsOpen(!isOpen)}>
        <BellIcon width={22} />
        {pendingCount > 0 && <span className={styles.badge}>{pendingCount}</span>}
      </button>
      {isOpen && (
        <div className={styles.dropdown}>
          <NotificationPanel
            notifications={notifications}
            onClose={() => setIsOpen(false)}
            onReload={onReload}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
